<h3 mat-dialog-title>เงื่อนไขการรับประกัน</h3>
<mat-dialog-content #dialogContent (scroll)="onScroll($event)">

  <h4>นโยบายการรับประกันยางรถยนต์ 60 วัน เปลี่ยนฟรี</h4>
  <p>
    นโยบายการรับประกันยางรถยนต์ บาด บวม แตก 60 วัน เปลี่ยนฟรี สําหรับผลิตภัณฑ์ยางรถยนต์โตโยไทร์, นิตโตะไทร์และ
    นันกังไทร์
    มีเงื่อนไขและข้อปฏิบัติดังนี้
  </p>
  <ol>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด จะรับประกันผลิตภัณฑ์ยางรถยนต์ภายใต้ยี่ห้อ โตโยไทร์, นิตโตะไทร์ และนันกังไทร์
      เฉพาะที่บริษัทฯนําเข้ามาจากต่างประเทศ ตามข้อกําหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบายการ รับประกันนี้เท่านั้น
      โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น ค่าบริการอันเกิดขึ้นจากการถอด ใส่ ค่าสูญเสียเวลา
      ค่าสูญเสียอันเนื่องจากการไม่ได้ใช้รถยนต์ ค่าความไม่สะดวกและผลจากการเสียหายอื่นตามที่ กฎหมายอนุญาต
    </li>
    <li>
      เมื่อเปลี่ยนยางรถยนต์ภายใต้ยี่ห้อ โตโยไทร์ หรือนิตโตะไทร์ หรือนันกังไทร์ทุกรุ่น ทุกขนาด จํานวน 4 เส้น ต่อรถ 1 คัน
      ต่อ 1 ใบเสร็จรับเงิน
      ที่ตัวแทนจําหน่ายยางรถยนต์อย่างเป็นทางการ ของ บริษัท ต.สยาม คอมเมอร์ เชียล จํากัด ทางบริษัทฯ
      จะมอบสิทธิ์การรับประกันยางชํารุดภายใน 60
      วัน นับตั้งแต่วันที่ระบุในใบเสร็จรับเงิน และ ใบรับประกัน (Warranty Card)
      และสิ้นสุดหรือหมดอายุการรับประกันตามวันที่ที่ได้ระบุไว้ในใบรับประกัน (Warranty Card)
    </li>
    <li>
      การรับประกันยางชํารุด 60 วัน ครอบคลุมยางชํารุดทั้งที่เกิดจากการใช้งานตามปกติ หรือเกิดจากการผลิต เช่น ยางโดนของมีคม
      บาด*
      แก้มยางบวมจากการกระแทก ตกหลุมอย่างแรง เบียดฟุตบาธ ยางปริแตก เป็นต้น แต่การรับประกันฯนี้
      ไม่ครอบคลุมความเสียหายของกระทะล้อ ล้อแม็กซ์
      หรือ อะไหล่เกี่ยวเนื่องอื่น ๆ และ ไม่ครอบคลุมถึง อุบัติเหตุ ความเสียหาย ต่อชีวิตและทรัพย์สิน
      รวมถึงการบาดเจ็บของผู้ใช้สินค้า ดังกล่าว
      หมายเหตุ * กรณียางถูกของมีคมบาดตําและสามารถปะซ่อมได้ จะไม่เข้าข่ายการรับประกันนี้ โดยผู้ใช้จะต้องเป็น
      ผู้รับผิดชอบค่าใช้จ่ายในการซ่อมแซม แต่ในกรณี บาดแผลใหญ่จนไม่สามารถทําการปะหรือ ซ่อมแซมได้ ทางบริษัทฯ
      จะทําการเปลี่ยนยางเส้นใหม่
      ตามเงื่อนไขที่กําหนดไว้ในนโยบายการรับประกันนี้
    </li>
    <li>บริษัทฯ จะเปลี่ยนยางให้สูงสุด 4 เส้น ต่อ 1 ใบเสร็จรับเงิน ภายในระยะเวลาการรับประกันยางชํารุด 60 วัน</li>
    <li>
      การขอรับการชดเชยยางในการรับประกันนี้ ผู้ขอรับประกันจะต้องนํายางที่ชํารุดเสียหายมาแสดงและส่งมอบต่อ
      ร้านค้าที่ซื้อยางเพื่อส่งคืนให้กับ
      ทางบริษัทฯ และต้องแนบใบเสร็จรับเงินพร้อมใบรับประกันฯ เพื่อการตรวจสอบ ข้อมูลยาง (ยี่ห้อ/รุ่น/ขนาด/DOT) และข้อมูลรถ
      ยี่ห้อ – รุ่นรถ /
      ทะเบียนรถ) จะต้องตรงกับข้อมูลที่ระบุไว้ใน ใบเสร็จรับเงิน และใบรับประกันฯ หากข้อมูลในใบรับประกันไม่ตรงกัน
      หรือไม่สามารถตรวจสอบข้อมูลดังกล่าวได้ ทางบริษัทฯ ขอสงวนสิทธิ์ ในการยกเลิกการรับประกัน เช่น ยางเสียหายจนไม่
      สามารถดูเลข DOT หรือ
      วันเดือนปี ที่ผลิตยางได้ เป็นต้น
    </li>
    <li>
      การเปลี่ยนยางเส้นใหม่ บริษัทฯ จะเปลี่ยนยาง ยี่ห้อ รุ่น และ ขนาด เดียวกัน กับยางเดิมที่ชํารุด ยกเว้น กรณีไม่มี
      ยางรุ่น ยี่ห้อ และ
      ขนาดเดิม ทางบริษัทฯ จะชดเชยยาง ยี่ห้อ หรือ รุ่นอื่นทดแทน และ หากยางใหม่ที่ชดเชย มีราคา สูงกว่า
      ผู้ขอรับประกันจะต้องชําระเงินส่วนต่างที่เกิดขึ้น โดยคิดคํานวณจากราคา ณ วันที่เปลี่ยนยางใหม่ กรณียาง ชํารุด
      และมีการเปลี่ยนยางเส้นใหม่
      ระยะการรับประกัน 60 วัน ยังคงนับจากวันที่ในใบเสร็จรับเงิน
    </li>
    <li>การเปลี่ยนยางเส้นใหม่ ไม่รวมถึงค่าบริการถอดและใส่ล้อ รวมถึงค่าบริการตั้งศูนย์ถ่วงล้อ และเติมลมยาง ไนโตรเจน</li>
    <li>
      ยางชํารุดที่ได้รับการรับการพิจารณาชดเชย จะตกเป็นกรรมสิทธิ์ของ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด และ
      ผู้ขอรับประกันจะไม่สามารถเรียกร้องขอรับคืนได้
    </li>
    <li>
      การรับประกันนี้ ไม่ครอบคลุมในกรณี ดังนี้
      <ol>
        <li>ความพึงพอใจในสินค้า เช่น เสียงของยาง ความแข็งกระด้างหรือนุ่มนวลของยาง</li>
        <li>ขนาดยาง รุ่นยาง ไม่ตรงกับการใช้งาน หรือ ไม่เหมาะสมกับตัวรถ</li>
        <li>การใช้งานที่ผิดประเภท หรือใช้เพื่อการแข่งขัน ยางที่ถูกซุ้มล้อบาด ยางชํารุดเนื่องจากการถอด ใส่ หรือ
          การประกอบกระทะล้อ</li>
        <li>
          ผู้ซื้อไม่ได้ลงทะเบียนรับสิทธิประโยชน์การรับประกันยางรถยนต์ บาด บวม แตก 60 วัน เปลี่ยนฟรี ภายใน 7 วัน
          นับจากวันที่ซื้อ รวมถึงกรณี
          ใบรับประกันชํารุดหรือสูญหาย
        </li>
        <li>มีการเปลี่ยนแปลงกรรมสิทธิ์หรือการครอบครองจากผู้ซื้อรายเดิม</li>
      </ol>
    </li>
    <li>
      ยางรถยนต์ภายใต้ยี่ห้อ โตโยไทร์ หรือนิตโตะไทร์ หรือนันกังไทร์ ที่เป็นยาง ติดรถใหม่ [Original Equipment] และ/ หรือ
      เป็นยางนําเข้ามาจากต่างประเทศโดยผู้นําเข้ารายอื่น ๆ ที่มิใช่ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด
      จะไม่ได้รับการรับประกันฯ
      ตามนโยบายฉบับนี้
    </li>
    <li>
      กรณียางชํารุดและผู้ขอรับประกันได้เปลี่ยนยางเส้นใหม่แล้ว ผู้ขอรับประกัน จะต้องนําส่งยางที่ชํารุดมาให้ บริษัท ต.สยาม
      คอมเมอร์เชียล
      จํากัด ตรวจสอบ และปฏิบัติตามเงื่อนไขที่ได้กําหนดไว้ในนโยบายการรับประกันนี้
    </li>
    <li>
      ผู้ขอรับประกัน เป็นผู้รับผิดชอบในการส่งยางชํารุดมาให้ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด และเป็นผู้
      รับภาระค่าขนส่ง
      โดยทางบริษัทจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใด ๆ ในระหว่างการขนส่ง
    </li>
    <li>
      ผลของการพิจารณาให้การชดเชยยางรถยนต์ที่ชํารุดเสียหาย ให้ถือเอาการพิจารณาของผู้แทนที่ได้รับการ แต่งตั้งจาก บริษัท
      โตโยไทร์แอนด์รับเบอร์
      จํากัด หรือ บริษัท นันกัง รับเบอร์ไทร์ คอร์ปอเรชั่น จํากัด เป็นที่สิ้นสุด และบริษัทฯ
      ขอสงวนสิทธิ์ในการเรียกเก็บเงินค่ายางที่ได้ทําการชดเชยไปแล้วกลับคืน
    </li>
    <li>
      บริษัทฯ ขอสงวนสิทธิ์ไม่ทําการเปลี่ยนยางเส้นใหม่ให้ ในกรณีที่ทางบริษัทฯ ได้ตรวจสอบยางที่ชํารุด ดังกล่าว และพบว่า
      การชํารุดของยางที่ขอรับประกันเกิดจากความตั้งใจ หรือ จงใจจากผู้ใช้งาน หรือตัวแทนจําหน่ายให้ เกิดความเสียหายดังกล่าว
    </li>
    <li>
      ผู้ขอรับประกัน จะต้องลงทะเบียนการรับประกันตามที่บริษัทฯกําหนด ให้ครบถ้วนและถูกต้องตาม ความเป็นจริง มิฉะนั้น
      การรับประกัน จะเป็นโมฆะ
      และ ไม่มีผลบังคับใช้
    </li>
    <li>
      ทางบริษัทฯ จะดําเนินการตามกฎหมายหากทําการตรวจสอบและพบว่าผู้ขอการรับประกัน และ/หรือร้านค้า และ/หรือ ตัวแทนจําหน่าย
      ได้ทําการทุจริตเพื่อให้ทางบริษัทฯ เกิดความเสียหายจากนโยบายการรับประกันดังกล่าว
    </li>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด ขอสงวนสิทธิ์ในการยกเลิก และ/หรือ แก้ไขเปลี่ยนแปลงนโยบายการ รับประกันฯนี้
      ทั้งหมดหรือส่วนหนึ่งส่วนใด
      เพื่อความเหมาะสม โดยไม่จําเป็นต้องแจ้งให้ทราบล่วงหน้า
    </li>
  </ol>



  <h4>นโยบายการรับประกันคุณภาพฯ สําหรับผลิตภัณฑ์ยางรถยนต์โตโยไทร์, นิตโตะไทร์และ นันกังไทร์ มีเงื่อนไขและ
    ข้อปฏิบัติดังนี้</h4>
  <ol>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด จะรับประกันผลิตภัณฑ์ยางรถยนต์ภายใต้ยี่ห้อ โตโยไทร์ , นิตโตะไทร์ และนันกังไทร์
      เฉพาะที่บริษัทฯนําเข้ามาจากต่างประเทศ ตามข้อกําหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบาย การรับประกันคุณภาพนี้เท่านั้น
      โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น ค่าบริการอันเกิดขึ้นจากการ ถอด ใส่ ค่าสูญเสียเวลา
      ค่าสูญเสียอันเนื่องจากการไม่ได้ใช้รถยนต์ ค่าความไม่สะดวกและผลจากการเสียหายอื่น ตามที่กฎหมายอนุญาต
    </li>
    <li>
      ผลิตภัณฑ์ยางรถยนต์ทุกเส้น จะได้รับการพิจารณาชดเชยต่อเมื่อได้รับการตรวจสอบเป็นที่แน่ชัดว่ายางชํารุด
      ดังกล่าวเกิดจากข้อบกพร่องในการออกแบบ กรรมวิธีการผลิต และ/หรือ วัสดุที่ใช้ในการผลิตเท่านั้น
    </li>
    <li>
      การประเมินความชํารุดเสียหายของยางรถยนต์ว่าเกิดขึ้นเนื่องจากผู้ใช้หรือผู้ผลิต การตัดสินขั้นสุดท้ายจะกระทํา
      โดยบุคคลที่ได้รับการแต่งตั้งจาก บริษัท โตโยไทร์แอนด์รับเบอร์ จํากัด หรือ บริษัท นันกัง รับเบอร์ไทร์ คอร์ ปอเรชั่น
      จํากัด
    </li>
    <li>
      การประเมินมูลค่าการชดเชย จะคํานวณจากระดับความลึกของร่องดอกยางที่เหลืออยู่ ซึ่งสามารถคํานวณได้ดังนี้
      <img src="../../assets/images/img-tirewarranty-01.webp" alt="tirewarranty01" style="width: 100%" />
      <p>การชดเชยจะกระทําโดยการขายยางใหม่ให้กับร้านค้าราคาดังนี้</p>
      <img src="../../assets/images/img-tirewarranty-02.webp" alt="tirewarranty02" style="width: 100%" />
      <p>หมายเหตุ :</p>
      <p>
        (1) ราคายาง คือ ราคาขายที่บริษัทฯขายยางที่ขอการรับประกันให้กับร้านค้านั้นๆ
        <br />
        (2) ราคายางใหม่ คือ ราคาในใบราคา (Price List) ของบริษัทฯที่ไม่รวมรายการส่งเสริมการขาย
      </p>
    </li>
    <li>
      ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางจากร้านค้ามายังบริษัทฯเพื่อขอให้บริษัทฯพิจารณา ชดเชย
      โดยบริษัทฯจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใด ๆในระหว่างการขนส่ง
    </li>
    <li>6. ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางที่ไม่ได้รับการชดเชยกลับคืนให้ลูกค้า</li>
    <li>
      ยางรถยนต์ที่มีลักษณะดังต่อไปนี้ จะไม่ได้รับการพิจารณาชดเชยและให้ถือว่าสิ้นสุดการรับประกัน ได้แก่
      <ol>
        <li>ยางชำรุดที่เกิดจากการถูกของแหลมคมบาด เช่น แผ่นเหล็ก เศษแก้ว หรืยางชำรุดที่เกิดจากการกระแทกกับก้อนหิน ขอบถนน
          ขอบหลุม</li>
        <li>ยางชํารุดที่เกิดจากการใช้ลมยางไม่ถูกต้อง หรือใช้กระทะล้อไม่ถูกต้อง หรือเกิดจากการใช้งานในขณะที่ไม่มี
          แรงดันลมยาง</li>
        <li>
          ยางสึกหรอผิดปกติ เนื่องจากการใช้แรงดันลมยางไม่ถูกต้อง ไม่มีการสลับตําแหน่งยาง การใช้กระทะล้อไม่ ถูกต้อง
          ความบกพร่องของช่วงล่าง
          ศูนย์ล้อ โช้คอัพ ระบบเบรค รวมถึงการไม่สมดุลของล้อหรือความบกพร่อง ของชิ้นส่วนอื่นๆของรถยนต์
        </li>
        <li>ยางชํารุดเนื่องจาก การใส่การถอดหรือการประกอบยางกับกระทะล้อไม่ถูกต้อง</li>
        <li>ยางที่เกิดปัญหาเต้นสั่น ภายหลังจากดอกยางสึกหรอไปแล้วมากกว่า 10%</li>
        <li>
          ยางที่ไม่ได้ซื้อขายผ่านผู้จัดจําหน่ายอย่างเป็นทางการจาก บริษัท โตโยไทร์แอนด์รับเบอร์ จํากัด หรือ บริษัท นันกัง
          รับเบอร์ไทร์
          คอร์ปอเรชั่น จํากัด
        </li>
        <li>ยางที่ถูกนําไปใช้ ไม่ถูกต้องตามข้อกําหนด หรือใช้ในการแข่งขัน หรือรถที่ใช้งานพิเศษ</li>
        <li>ยางที่ถูกใช้งานจนความลึกของร่องยางเหลือน้อยกว่า 2.0 มิลลิเมตร</li>
        <li>ยางที่มีการชํารุดเสียหายสืบเนื่องมาจากการปะ – ซ่อม หรือยางหล่อดอก</li>
        <li>ยางที่เกิดอาการเสียงยางผิดปกติ อันเนื่องมาจากการสึกหรอผิดปกติของดอกยาง</li>
      </ol>
    </li>
    <li>ระยะเวลาการรับประกัน : ตลอดอายุการใช้งาน</li>
    <li>
      ผลของการพิจารณาให้การชดเชยยางรถยนต์ที่ชํารุดเสียหาย ให้ถือเอาการพิจารณาของผู้แทนที่ได้รับการแต่งตั้ง จากบริษัท
      โตโยไทร์แอนด์รับเบอร์
      จํากัด หรือ บริษัท นันกัง รับเบอร์ไทร์ คอร์ปอเรชั่น จํากัด เป็นที่สิ้นสุด
    </li>
    <li>ยางชํารุดที่ได้รับการพิจารณาให้การชดเชย ให้ตกเป็นกรรมสิทธิ์ของ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด</li>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด ขอสงวนสิทธิ์ในการยกเลิก และ / หรือ แก้ไขเปลี่ยนแปลงนโยบายการ
      รับประกันคุณภาพฯนี้
      ทั้งหมดหรือส่วนหนึ่งส่วนใด เพื่อความเหมาะสม โดยไม่จําเป็นต้องแจ้งให้ทราบล่วงหน้า
    </li>
  </ol>
</mat-dialog-content>
@if(!showButtonConfirm){
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="cancel()">ปิด</button>

</mat-dialog-actions>
}

@if(showButtonConfirm){
<mat-dialog-actions class="center">
  <button class="confirmAcceptance" mat-button mat-flat-button (click)="confirmAcceptance()"
    [disabled]="!isScrolledToBottom">ยอมรับ</button>
</mat-dialog-actions>
}
